import { render } from "./MenuSideBar.vue?vue&type=template&id=58111274&ts=true"
import script from "./MenuSideBar.vue?vue&type=script&lang=ts"
export * from "./MenuSideBar.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__